// extracted by mini-css-extract-plugin
export var layoutContainer = "_5i-0";
export var layoutContainerNoRounding = "_5i-6";
export var layoutContainerOpen = "_5i-5";
export var layoutContainerResizing = "_5i-1";
export var mainContent = "_5i-2";
export var resizeDivider = "_5i-3";
export var slidePanel = "_5i-4";